var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scenario-container muzik-performer mk-container"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('LayoutList',{attrs:{"title":"演出者列表","type":"performer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }